<template>
  <div class="start">

    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-text">
        <h1>Koblenz mit Baby - Die Community für Austausch und Veranstaltungsnews</h1>
        <p>Ihr seid bereits Eltern eines Babys oder auf dem Weg dahin? Und ihr wüsstet gern, wann <strong>der nächste Kinderflohmarkt oder Babykurs</strong> stattfinden, wo es <strong>Krabbelgruppen, Babyschwimmen und Sportkurse für Schwangere</strong> gibt, oder was Koblenz sonst noch so für frisch gebackene Familien zu bieten hat?</p>
        <p>Dann schaut gern in unserer WhatsApp Community vorbei! Neben allgemeinem Erfahrungsaustausch sammeln wir in den Untergruppen interessante Veranstaltungen und Kursangebote für euch.</p>
        <p>
            <br/><a class="cta-button" href="https://chat.whatsapp.com/IQo7hXYjVXq9Fm5m7SyeJ5?mode=ac_t" aria-label="WhatsApp Community für Kowelenzer Eltern" target="_blank" rel="noopener noreferrer">Jetzt der Community beitreten!</a>
        </p>
        <p>
            <br/><button class="cta-button" @click="$router.push('/veranstaltungen/')">-> Zu den Veranstaltungsnews!</button>
            <button class="cta-button" @click="$router.push('/kurse/')">-> Zu den fortlaufenden Angeboten!</button>
        </p>
      </div>
      <div class="hero-image">
        <img src="@/assets/koblenz_mit_baby.jpg" alt="Koblenz mit Baby - Die Community für junge Eltern in Koblenz" width="300" height="auto"/>
      </div>
    </section>

  </div>
</template>
